import { render, staticRenderFns } from "./NewFieldTeamFromProject.vue?vue&type=template&id=320be458&scoped=true&"
import script from "./NewFieldTeamFromProject.vue?vue&type=script&lang=js&"
export * from "./NewFieldTeamFromProject.vue?vue&type=script&lang=js&"
import style0 from "./NewFieldTeamFromProject.vue?vue&type=style&index=0&id=320be458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320be458",
  null
  
)

export default component.exports